import { useCallback, useEffect } from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router'
import { Dispatch } from '@reduxjs/toolkit'

import type { GlobalState } from '../types'
import { uploadClear, uploadSelectCategory } from './upload-actions'
import { UploadContainer } from './UploadContainer'

type UploadProps = {
  requesting: boolean
  finished: boolean
  category: string
  onClear(): void
  onSelectCategory(category: string): void
}

const UploadComponent = (props: UploadProps) => {
  const { requesting, finished, onClear, onSelectCategory, category } = props
  const navigate = useNavigate()

  // updated from componentDidMount
  useEffect(() => {
    document.title ='File Uploads - Uploads'
  }, [])

  const onClickBackButton = useCallback(() => {
    if (finished) {
      onClear()
    }

    if(category){
      onSelectCategory('')
    }

    navigate(`${window.travURI}identity`)
  }, [finished, onSelectCategory, onClear, category,navigate])


  return (
    <UploadContainer
      clickBackButton={onClickBackButton}
      requesting={requesting}
    />
  )
}

const mapStateToProps = (state: GlobalState) => ({
  finished: state.upload.finished,
  requesting: state.upload.requesting,
  category: state.upload.category
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onClear: () => dispatch(uploadClear()),
  onSelectCategory: (category: string) => dispatch(uploadSelectCategory(category))
})

const Upload = connect(mapStateToProps, mapDispatchToProps)(UploadComponent)

export {
  Upload,
  UploadComponent // For testing without HOC
 }
